import { t } from "@/i18n-js/instance";
import { useMemberTags } from "@circle-react/components/SettingsApp/Workflows/hooks/useMemberTags";
import { FormTextSelect } from "@circle-react-uikit/Form/FormTextSelect";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { useCurrentAction } from "../../../ActionRule";

const i18nRoot = "settings.workflows.form";

export const FormTag = () => {
  const { paramsPath } = useCurrentAction();

  const {
    memberTags: unmappedActions = [],
    isLoading,
    isError,
  } = useMemberTags();

  const memberTags = unmappedActions.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

  if (isLoading) {
    return <Loader center />;
  }

  if (isError) {
    return (
      <Typography.LabelXs>
        <span className="text-v2-danger">
          {t([i18nRoot, "member_tags.fetch_failed"])}
        </span>
      </Typography.LabelXs>
    );
  }

  return (
    <FormTextSelect
      name={`${paramsPath}.member_tag_id`}
      label={
        <Typography.LabelSm weight="semibold">
          {t([i18nRoot, "select_tag"])}
        </Typography.LabelSm>
      }
      options={memberTags}
      rules={{
        required: t([i18nRoot, "errors.required"]),
      }}
      emptyMessage={t([i18nRoot, "errors.member_tags.not_found"])}
    />
  );
};
